const aInputDatePrimary = {
  aInputDatePrimary: {
    alerts: {
      updateDate: {
        error: 'Fecha incorrecta...'
      }
    },

    validation: {
      day: {
        minLength: 'Dia debe contener 2 digitos...',
        numeric: 'Solo numeros',
        between: 'Los meses tienen entre 28, 29 "año bisiesto", 30, 31 dias',
        required: 'No ingreso un dia...'
      },

      month: {
        required: 'No selecciono un mes...'
      },

      year: {
        minLength: 'Año debe contener 4 digitos...',
        numeric: 'Solo numeros...',
        required: 'No ingreso un año...'
      }
    }
  }
}

export default aInputDatePrimary
